var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.393,
    height: 14,
    viewBox: "0 0 15.393 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_email",
    "data-name": "icona email",
    transform: "translate(-90.304 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_mail",
    "data-name": "icona mail",
    transform: "translate(91 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M4.4,6H15.6A1.4,1.4,0,0,1,17,7.4v8.4a1.4,1.4,0,0,1-1.4,1.4H4.4A1.4,1.4,0,0,1,3,15.8V7.4A1.4,1.4,0,0,1,4.4,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M17,9l-7,4.9L3,9",
    transform: "translate(-3 -7.6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_762",
    "data-name": "Rettangolo 762",
    transform: "translate(91 29)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cb9c1c4b639d20d51c23809854151ab8.svg";
export { ForwardRef as ReactComponent };